<template>
  <el-container class="goods-trace-container">
    <!-- 顶部Header：商品溯源 -->
    <el-header style="height: 50px;">
      <div class="header-content">
        <h1 class="title">商品溯源</h1>
      </div>
    </el-header>

    <!-- 中间主体内容 -->
    <el-main class="page-main">
      <!-- 加载状态提示（请求未完成时显示） -->
      <div class="loading-container" v-if="isLoading">
        <div class="loading-spinner" :style="{ width: size, height: size }"></div>
        <p class="loading-text">{{ text }}</p>
      </div>

      <!-- 错误状态提示（请求失败/参数缺失时显示） -->
      <div class="error-container" v-if="!isLoading && errorMsg">
        <p class="error-text">{{ errorMsg }}</p>
      </div>

      <!-- 商品核心信息（请求成功且数据有效时显示） -->
      <div class="content" v-if="!isLoading && !errorMsg && goodInfo&& skuinfo">
        <!-- 商品图片+基础信息 -->
 

        <!-- 商品溯源详情信息 -->
        <div class="goods-trace-detail">
                 <div class="goods-base-info">
          <img 
            :src="skuinfo.img || 'https://byds.oss-cn-beijing.aliyuncs.com/20240922152235.png'" 
            alt="商品图片" 
            class="product-image"
          >
          <div class="goods-base-detail">
            <div class="goods-title">{{ skuinfo.title || '未知商品' }}</div>
            <div class="goods-barcode">条码：{{ skuinfo.outer_sku_code || '无条码信息' }}</div>
             <div class="goods-barcode">SN码：{{ sn}}</div>
          </div>
        </div>
          <div class="detail-item">激活日期：{{ activate_info.activate_time ? activate_info.activate_time : '未激活' }}</div>
           <div class="detail-item">激活天数：{{ activate_info.activate_day ? activate_info.activate_day + '天' : '0天' }}</div>
          <div class="detail-item">质保天数：{{ activate_info.warranty_days || '0天' }}</div>
          <div class="detail-item">延保天数：{{ activate_info.extended_warranty_days || '0天' }}</div>
          <div class="detail-item">
            激活状态：
            <span :class="activate_info!=null && activate_info.status === 1  ? 'status-active' : 'status-inactive'">
              {{ activate_info.status === 1 ? '已激活' : '未激活' }}
            </span>

                <el-button 
          type="primary" 
          @click="handleToActivate" 
          size="small"
          v-if="!activate_info.status && activate_url"
          style=" position: absolute; right: 0;bottom: 0;  "
        >
          立即激活
        </el-button>
        <el-button 
          type="primary" 
          @click="handleToActivate" 
          size="small"
          v-if="activate_info.status && activate_url"
          style=" position: absolute; right: 0;bottom: 0;  "
        >
          查看详细信息
        </el-button>
          </div>

          <div class="detail-item" style="display: flex;">激活图片：
            <el-image  v-if="activate_info.status"
    style="width: 80px; height: 80px"
    :src="activate_info.image " 
    :preview-src-list="[activate_info.image]">
    
  </el-image>
          </div>
        </div>
      </div>
 
      <!-- 商品溯源时间线 -->
                <!-- :type="activity.type || 'success'"
            :color="activity.color || '#08cd7e'" -->
                 <!-- :icon="activity.icon || 'el-icon-s-data'" -->
      <div class="timeline" v-if="!isLoading && !errorMsg">
        <el-timeline>
          <el-timeline-item
            placement="top"
            v-for="(activity, index) in activities"
            :key="index"
            :color="activity.color || '#08cd7e'"
            :type="activity.type"
            :size="activity.size || 'large'"
            :timestamp="activity.timestamp || '未知时间'"
          >
            <el-card v-if="activity.action_type!='激活'">
                <div class="timeline-content">
                    <div class="timeline-type"> 操作:{{ activity.action_type || '未知操作' }}</div>
                    <div class="timeline-warehouse">仓库:{{ activity.warehouseLabel || '未知仓库' }}</div>
                    <div class="timeline-contact">仓主:{{ activity.contact_name || '未知联系人' }}</div>
                    <!-- <div class="timeline-address">地址:{{ activity.address || '未知地址' }}</div> -->
                </div>
            </el-card>
            <el-card v-else>
                <div class="timeline-content">
                    <div class="timeline-type"> 操作:{{ activity.action_type || '未知操作' }}</div>
                </div>
            </el-card>
          </el-timeline-item>
        </el-timeline>
      </div>
    </el-main>

    <!-- 底部按钮区域 -->
    <el-footer class="page-footer" style="background-color:#409eff;"  v-if="!isLoading && !errorMsg && goodInfo&& skuinfo">
      <div   class="footer-content"  @click="handleBuy"  >
        <span v-if="payStatus === 0 && wx_url" style="color: #fff; font-size: 16px;" >
 立即购买
        </span>
        
        <!-- 立即购买按钮（pay_status=0 且有购买链接时显示） -->
        <span class="activated-tip" v-if="payStatus === 1">商品不在仓库</span>
      </div>
    </el-footer>
  </el-container>
</template>

<script>

export default {
  name: 'PayStatusRedirect',
  props: {
    size: {
      type: String,
      default: '40px',
      description: '转圈效果的尺寸（适配Element UI）'
    },
    color: {
      type: String,
      default: '#08cd7e',
      description: '主题色（按钮/加载动画/激活状态）'
    },
    showText: {
      type: Boolean,
      default: true,
      description: '是否显示提示文字'
    },
    text: {
      type: String,
      default: '加载中...',
      description: '默认加载文字'
    }
  },
  data() {
    return {
      isLoading: true, // 控制加载动画显示/隐藏
      payStatus: null, // 存储接口返回的 pay_status
      errorMsg: '', // 存储错误提示（如“查找不到商品”）
      sn: '', // 存储URL中的sn参数
      wx_url: "", // 购买链接
      activate_url: '', // 激活链接
      shop_id: '', // 店铺ID
      other_id: '', // 其他参数
      goodInfo: null, // 存储商品完整信息（图片/名称/条码/质保等）
      skuinfo: null, // 存储商品SKU信息（图片/名称/条码/质保等）
      activities: [], // 时间线数据（适配el-timeline）
      temfullUrl: '', // 完整URL
      activate_info: null, // 存储激活信息（日期/天数）

    };
  },
  created() {
    const fullDomain = window.location.origin;
    const fullUrl = window.location.href;
    this.temfullUrl = fullUrl;
    console.log("完整URL：", this.temfullUrl);
    this.sn = "";
    // 提取URL中的sn参数
    if (fullUrl.indexOf(fullDomain + "/shop/#/s/") > -1) {
      // 先替换前缀，再截断问号及之后的内容
      this.sn = fullUrl.replace(fullDomain + "/shop/#/s/", "").split('?')[0];

    } else {
      // 处理另一种前缀格式，同样截断问号及之后的内容
      this.sn = fullUrl.replace(fullDomain + "/#/s/", "").split('?')[0];
    }
    // 提取路由参数（无?.，直接访问，兼容旧版JS）
    this.other_id = this.$route.params.other_id;
    this.shop_id = this.$route.params.shop_id;
    console.log("提取的sn参数：", this.sn);

    // 校验sn参数是否为空
    if (this.sn === "") {
      this.isLoading = false;
      this.errorMsg = '缺少商品参数，无法查询';
      return;
    }
  console.log("完整URL：", this.temfullUrl);
    // 发起接口请求，获取商品状态及完整信息
    this.fetchPayStatus();
  },
  methods: {
    // 发起接口请求：查询商品的pay_status及完整信息
    async fetchPayStatus() {
      try {
        const encodedFullUrl = encodeURIComponent(this.temfullUrl);
        const res = await this.$get(`${this.$api.find_by_sn}?shop_id=${this.shop_id}&other_id=${this.other_id}&sn=${this.sn}&fullUrl=${encodedFullUrl}`);
        
        // 关闭加载动画
        this.isLoading = false;

        // 处理接口返回结果为空的情况
        if (!res || !res.data) {
          this.errorMsg = '查找不到该商品，请检查参数';
          return;
        }

        // 解构接口返回数据
        const { pay_status, url, activate_url, good_info, good_history,sn,activate_info } = res.data;
        this.payStatus = pay_status;
        this.wx_url = url;
        this.activate_url = activate_url;
        this.goodInfo = good_info || null;
        if(activate_info!=null)
        {
          this.activate_info = {
          activate_time:activate_info.activate_time|| null,
          warranty_days:activate_info.warranty_days|| null,
          image:activate_info.image || null,
          status:activate_info.status || 0,
          activate_day: new Date().getTime() - new Date(activate_info.activate_time).getTime() >= 0 ? Math.floor((new Date().getTime() - new Date(activate_info.activate_time).getTime()) / (1000 * 60 * 60 * 24)) || null : null,
        };
        }else{
          this.activate_info = {
          activate_time: null,
          warranty_days: null,
          status: 0,
          image: null,
          activate_day:0,
        };
        }
       
        this.sn = sn
        if (this.goodInfo) {
          this.skuinfo = this.goodInfo.sku || null;
        }
        if( activate_info!=null && good_history!=null)
        {
          good_history.push({
            add_time:this.activate_info.activate_time,
            type:"activate",
        })
        }
        // 构建时间线数据（适配el-timeline组件，移除?.）
        this.buildTimelineData(good_history || []);

        // pay_status=1 → 自动跳转到指定链接（保留原有逻辑）
        if (this.payStatus === 1 && url) {
          window.location = url;
        }

      } catch (err) {
        // 捕获请求错误（如网络异常、接口报错）
        this.isLoading = false;
        this.errorMsg = '加载失败，请稍后重试';
        console.error('请求异常：', err);
      }
    },

    // 构建el-timeline所需的时间线数据（移除所有?.，用&&逐级判断）
    buildTimelineData(historyList) {
      // 按时间倒序排序
      const sortedList = historyList.sort((a, b) => {
        const timeA = a.add_time ? new Date(a.add_time).getTime() : 0;
        const timeB = b.add_time ? new Date(b.add_time).getTime() : 0;
        return timeB - timeA;
      });

      // 转换为el-timeline适配格式（移除?.，用&&判断嵌套属性）
      this.activities = sortedList.map(item => {
        // 处理仓库信息：用&&逐级判断，替代item.warehouse?.label
        if(item.type=="activate")
      {
       return {
          timestamp: item.add_time || '未知时间',
          action_type:'激活',
          color:'#ff4949',
        };
      }else{
        const warehouseLabel = item.warehouse && item.warehouse.label ? item.warehouse.label : '未知仓库';
        const action_type = item.inout.invoice_type === "in" ? "入库" : "出库";
        const color = item.inout.invoice_type === "in" ? "#08cd7e" : "#409eff";
        // #ff4949"
        const contact_name = item.warehouse.contact_name || '未知联系人';
        const address = item.warehouse.address || '未知地址';
         return {
          timestamp: item.add_time || '未知时间',
          warehouseLabel:warehouseLabel,
          action_type:action_type,
          color:color,
          contact_name:contact_name,
          address:address
        };
      }
        

       
      });

      // 若无溯源记录，添加默认提示
      if (this.activities.length === 0) {
        this.activities = [{
          timestamp: '无记录',
          content: '该商品暂无溯源记录',
          icon: 'el-icon-info',
          type: 'info'
        }];
      }
    },

    // 点击购买按钮：跳转到购买链接
    handleBuy() {
      if (this.wx_url) {
        window.location = this.wx_url;
      } else {
        this.errorMsg = '购买链接无效，请联系客服';
      }
    },

    // 点击立即激活按钮：跳转到激活链接
    handleToActivate() {
      if (this.activate_url) {
        window.location = this.activate_url;
      } else {
        this.errorMsg = '激活链接无效，请联系客服';
      }
    }
  }
};
</script>

<style scoped>

/* 全局容器样式 */
.goods-trace-container {
  height: 100vh;
  font-family: -apple-system, BlinkMacSystemFont, "Helvetica Neue", "PingFang SC", sans-serif;
}

/* 顶部Header样式 */
/deep/.page-header {
  padding: 0;
  height: 50px;
  background-color: #fff;
  border-bottom: 1px solid #f0f0f0;
}

.header-content {
  text-align: center;
  height: 50px;
  line-height: 50px;
}

.title {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #333;
}

/* 中间主体样式 */
/deep/.page-main {
  padding: 10px;
  background-color: #f8f9fa;
  overflow-y: auto;
}

/* 加载状态样式 */
.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 60vh;
}

.loading-spinner {
  border: 4px solid rgba(0, 0, 0, 0.1);
  border-top-color: v-bind(color);
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

.loading-text {
  margin-top: 15px;
  font-size: 16px;
  color: #666;
}

/* 错误状态样式 */
.error-container {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 60vh;
}

.error-text {
  font-size: 16px;
  color: #ff4444;
  text-align: center;
  padding: 0 20px;
}

/* 商品内容样式 */
.content {
  margin-bottom: 30px;
}

/* 商品基础信息（图片+名称+条码） */
.goods-base-info {
  display: flex;
  background-color: #fff;
  border-radius: 8px;
  margin-bottom: 10px;
}

.product-image {
  width: 100px;
  height: 100px;
  object-fit: cover;
  border-radius: 8px;
  border: 1px solid #f0f0f0;
}

.goods-base-detail {
  margin-left: 20px;
}

.goods-title {
  font-size: 18px;
  font-weight: 600;
  color: #333;
  /* margin-bottom: 10px; */
}

.goods-barcode {
  font-size: 16px;
  color: #666;
}

/* 商品溯源详情 */
.goods-trace-detail {
  background-color: #fff;
  padding: 20px;

}

.detail-item {
  position: relative;
  font-size: 16px;
  color: #666;
  margin-bottom: 10px;
}

.detail-item:last-child {
  margin-bottom: 0;
}

/* 激活状态样式 */
.status-active {
  color: #08cd7e !important;
  font-weight: 500;
}

.status-inactive {
  color: #ff9500 !important;
  font-weight: 500;
}

/* 时间线样式 */
.timeline {
  background-color: #fff;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.timeline-content {
  font-size: 14px;
  color: #666;
  line-height: 1.6;
}

/* 底部Footer样式 */
.page-footer {
  padding: 20px;
  background-color: #fff;
  border-top: 1px solid #f0f0f0;
}

.footer-content {
  text-align: center;
}

/* 已激活提示样式 */
.activated-tip {
  font-size: 14px;
  color: #666;
  line-height: 36px;
}
/deep/.el-timeline{
  padding: 0;
}
/deep/.el-card__body{
  padding: 10px;
}
</style>


// WEBPACK FOOTER //
// src/views/skip/index2.vue